import React from 'react';
import useStyles from './styles';

export type VideoEditOrderCheckProps = {
  additionalMinutes: number;
  creditsRemaining: number;
  firstEditPrice: number;
  firstEditTitle: string;
  totalPrice: number;
  isPlan: boolean;
  comment?: string;
  inModal?: boolean;
};

const VideoEditOrderCheck = ({
  additionalMinutes,
  creditsRemaining,
  firstEditPrice,
  firstEditTitle,
  totalPrice,
  isPlan,
  inModal,
}: VideoEditOrderCheckProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}> Video Credits & {inModal && <br />} Estimated Fees </div>
      <div className={classes.description}>Charges will be processed after the video is approved</div>
      <hr className={classes.lineBreak} />
      <div>
        {isPlan
          ? <div>
            <div className={classes.blockTitle}> Video Credit: <b> 1 </b> </div>
            <div className={classes.blockDescription}> {creditsRemaining} video credits remaining </div>
          </div>
          : <div>
            <div> </div>
            <div> </div>
          </div>}
      </div>
      <div>
        <div className={classes.blockTitle}> Additional Minutes: <b> {additionalMinutes || null } </b> </div>
        <div className={classes.blockDescription}> $10 per minute
          {additionalMinutes ? <span> x {additionalMinutes} = ${additionalMinutes * 10} </span> : null }
        </div>
      </div>
      <div>
        <div className={classes.blockTitle}> First Edit: <b> {firstEditTitle} </b> </div>
        <div className={classes.blockDescription}> {firstEditPrice ? `$${firstEditPrice}` : null} </div>
      </div>
      <hr className={classes.lineBreak} />
      <div className={classes.footer}> Total Estimated Fees: ${totalPrice}</div>
    </div>
  );
};

export default VideoEditOrderCheck;
